var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhats0PpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 25.0001C12.2607 26.2239 15.0051 26.5554 17.6136 25.9348C20.2221 25.3142 22.5232 23.7823 24.1022 21.6153C25.6812 19.4482 26.4343 16.7884 26.2257 14.1153C26.0172 11.4421 24.8607 8.93127 22.9648 7.0353C21.0688 5.13933 18.558 3.98287 15.8848 3.77433C13.2116 3.56579 10.5518 4.31887 8.38477 5.89787C6.21771 7.47687 4.68586 9.77795 4.06528 12.3864C3.44469 14.995 3.77618 17.7393 5 20.1251L2.5 27.5001L9.875 25.0001Z",
    stroke: "#EAEAEA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhats0PpIcon);
export default __webpack_public_path__ + "static/media/WHATS0PPIcon.3e2ac3d89dc3575f463c5e2a7cab299b.svg";
export { ForwardRef as ReactComponent };